// TicketMiniDetail.js
import React from 'react';
import Status from '../../../components/ui/Status';

const TicketMiniDetail = ({ ticketDetail }) => {
    if (!ticketDetail) return null;
    
    const tickets = Array.isArray(ticketDetail) ? ticketDetail : [ticketDetail];

    return (
        <div>
            {tickets && tickets.map((ticket, index) => {
                const ticketData = ticket?.data ;
                return (
                    <>
                        <label className='pt-1'><span className='alert-text'>Ticket Header : </span> {ticketData?.header ?? "-"}</label><br />
                        <label className='pt-1'><span className='alert-text'>Ticket ID : </span> {ticketData?.activity_id ?? "-"}</label><br />
                        <label className='pt-1'><span className='alert-text'>Ticket For : </span> {ticketData?.ticket_for_name ?? "-"}</label><br />
                        {ticketData?.ticket_for == "asset" && (<>
                            <label className='pt-1'><span className='alert-text'>Asset : </span> {ticketData?.asset?.asset_type_name ?? "-"} ({ticketData?.asset?.asset_code ?? "-"})</label><br /></>)}
                        {ticketData?.ticket_for == "sub_assembly" && (<>
                            <label className='pt-1'><span className='alert-text'>Sub Assembly : </span> {ticketData?.subAssembly?.name ?? "-"} ({ticketData?.subAssembly?.code ?? "-"})</label><br /></>)}
                        {ticketData?.ticket_for == "site" && (<>
                           <label className='pt-1'><span className='alert-text'>Site : </span> {ticketData?.site?.site_name ?? "-"}  ({ticketData?.site?.site_code ?? "-"}) </label><br /></>)}
                           {ticketData?.ticket_for == "workstation" && (<>
                           <label className='pt-1'><span className='alert-text'>WorkStation : </span> {ticketData?.workStation?.name ?? "-"}  ({ticketData?.workStation?.code ?? "-"}) </label><br /></>)}
                             {/* {ticketData?.ticket_for == "employee" && (<>
                           <label className='pt-1'><span className='alert-text'>Employee : </span> {ticketData?.employee?.name ?? "-"}  ({ticketData?.employee?.code ?? "-"}) </label><br /></>)} */}
                        <label className='pt-1'><span className='alert-text'>Ticket Type : </span> {ticketData?.ticket_type_name ?? "-"}</label><br />
                                            
                        <label className='pt-1'><span className='alert-text'>Status:</span> <Status color={ticketData?.status_color_code}>{ticketData?.status_text}</Status></label><br/>
                    </>

                );
            })}
        </div>
    );
};


export default TicketMiniDetail;